import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import { forgotPassword } from '../services/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await forgotPassword(email);
      // Always show the same success message, whether or not the email exists —
      // this is intentional and matches what the backend does, to avoid
      // revealing which emails are registered.
      setSubmitted(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <PageHeader eyebrow="Account Recovery" title="Forgot Your Password?" />
      <section className="section">
        <div className="container" style={{ maxWidth: 420 }}>
          <div className="card">
            {submitted ? (
              <div className="success-box">
                If an account exists for <strong>{email}</strong>, we've sent a password
                reset link to that email address. It will expire in 1 hour.
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <p style={{ marginBottom: 20 }}>
                  Enter the email address on your account and we'll send you a link to
                  reset your password.
                </p>
                {error && <p className="error-text" style={{ marginBottom: 16 }}>{error}</p>}
                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <button type="submit" className="btn btn-gold btn-block" disabled={loading}>
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </form>
            )}
            <p style={{ textAlign: 'center', marginTop: 16, fontSize: '0.9rem' }}>
              <Link to="/login" style={{ color: 'var(--color-gold)', fontWeight: 600 }}>Back to Login</Link>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
